export enum UserProfileType {
  User = 'user',
  AssociationUser = 'association-user',
  AssociationOwner = 'association-owner',
}
